// extracted by mini-css-extract-plugin
module.exports = {"input":"date-picker_input__S1afM"};